"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSCRIPTION_PLANS = void 0;
var room_tour_3d_svg_1 = __importDefault(require("../../images/subscription/room_tour_3d.svg"));
var subscription_tour_btn_svg_1 = __importDefault(require("../../images/subscription/subscription_tour_btn.svg"));
var update_to_top_svg_1 = __importDefault(require("../../images/subscription/update_to_top.svg"));
var subscription_pin_btn_svg_1 = __importDefault(require("../../images/subscription/subscription_pin_btn.svg"));
exports.SUBSCRIPTION_PLANS = [
    {
        id: process.env.MIX_UPDATE_TO_TOP_SUBSCRIPTION_PLAN_ID,
        name: 'pin_to_top',
        options: {
            defaultStep: 3,
            defaultMaxDaysCount: 30,
        },
        btnExtendedStyles: ['outline'],
        mainIcon: update_to_top_svg_1.default,
        btnIcon: subscription_pin_btn_svg_1.default,
        hasPostCard: false,
        hasForm: true,
        paymentBank: 'evoca',
        currency: '051',
    },
    {
        id: process.env.MIX_TOUR_3D_SUBSCRIPTION_PLAN_ID,
        name: 'tour_3d',
        options: {
            defaultStep: 1,
            defaultMaxDaysCount: 1,
        },
        btnExtendedStyles: ['primary'],
        mainIcon: room_tour_3d_svg_1.default,
        btnIcon: subscription_tour_btn_svg_1.default,
        hasPostCard: true,
        hasForm: false,
        paymentBank: 'evoca',
        currency: '051',
    },
];
